export default __webpack_public_path__ + "static/media/a2d2.7cc2543f.png";